// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonFilters = {
  all: "全部",
  createdBy: "创建人",
  updatedBy: "更新人",
} as const;
